var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50883 8.1502C4.71047 10.8021 6.64644 12.9667 9.008 14.3255L10.8438 12.2639C11.0691 12.0109 11.4029 11.9266 11.695 12.039C12.6296 12.3857 13.6393 12.5731 14.6741 12.5731C15.133 12.5731 15.5085 12.9948 15.5085 13.5102V16.7806C15.5085 17.2959 15.133 17.7176 14.6741 17.7176C6.83837 17.7176 0.488037 10.5866 0.488037 1.78753C0.488037 1.27214 0.86355 0.850464 1.32251 0.850464H4.24316C4.70212 0.850464 5.07764 1.27214 5.07764 1.78753C5.07764 2.95886 5.24453 4.08334 5.55329 5.13285C5.64508 5.46082 5.57832 5.82628 5.34467 6.08866L3.50883 8.1502Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGreen);
export default __webpack_public_path__ + "static/media/call_green.e393d9de50c280f5b51e7e384e3195eb.svg";
export { ForwardRef as ReactComponent };